import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey1, grey4 } from 'approot/shared/styles/colours.style';
import {
  spacing12,
  spacing16,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/buttons';

export const ImageLightbox = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${rem(spacing40)};
  position: relative;
  transition: all 300ms ease;
`;

export const ImageLightboxWrapper = styled.div`
  ${flexCentreAlignCss}

  border-radius: ${rem(borderRadius8)};
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

type ImageLightboxImageProps = {
  isLoading: boolean;
};
export const ImageLightboxImage = styled.figure<ImageLightboxImageProps>`
  margin: 0;
  flex-grow: 1;
  position: relative;

  img {
    background-color: ${grey1};
    ${({ isLoading }) =>
      !isLoading
        ? `
      opacity: 1;
      visibility: visible;
      transition: opacity 600ms ease, visibility 0ms linear;
    `
        : `
      opacity: 0;
      visibility: hidden;
      transition: opacity 0s ease, visibility 0s ease;
    `}
  }
`;

type ImageLightboxCaptionProps = {
  $isCollapsed?: boolean;
};
export const ImageLightboxCaption = styled.div<ImageLightboxCaptionProps>`
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey4};
  min-height: ${rem(58)};
  padding: ${rem(spacing12)};
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${rem(30)};
  z-index: 1;

  ${({ $isCollapsed }) =>
    $isCollapsed &&
    `
      left: auto;
      width: ${rem(256)};
      & > div {
        display: none;
      }
  `}
`;

export const ImageLightboxCaptionButton = styled(SecondaryButtonIcon)<
  ImageLightboxCaptionProps
>`
  height: ${rem(32)};
  min-width: auto;
  position: absolute;
  right: ${rem(spacing16)};
  top: ${rem(spacing12)};
  width: ${rem(32)};
  z-index: 4;

  ${({ $isCollapsed }) =>
    $isCollapsed &&
    `
    svg {
      transform: rotate(180deg);
    }
  `}
`;
